/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from "react"
import cx from "classnames"
import {
  RadioGroup,
  RadioGroupProps as MantineRadioGroupProps,
} from "@mantine/core"
import { RadioGroupProps as MUIRadioGroupProps } from "@mui/material"
import withMappedProps from "hoc-lib/propsMapping"

import styles from "./RadioGroup.mantine.module.scss"

export const MantineRadioGroup = RadioGroup
export default MantineRadioGroup

const muiToMantine = (props: MUIRadioGroupProps): MantineRadioGroupProps => {
  const anyProps: any = props
  return {
    ...anyProps,
    className: cx(props.className, styles.root),
  }
}

export const MUIMappedRadioGroup = withMappedProps(
  MantineRadioGroup,
  muiToMantine,
)
